import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-campaign',
    templateUrl: './campaign.component.html',
    styleUrls: ['./campaign.component.scss'],
})
export class TableCampaignComponent implements OnInit {

    @Input('data') config;
    constructor() { }

    ngOnInit() { }

}
